import "./AllListings.scss";
import axios from "axios";
import SingleListing from "../SingleListing/SingleListing";
import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { Form } from "react-bootstrap";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
const { REACT_APP_API_ENDPOINT } = process.env;

export default function AllListings(props) {
  const [listingData, setListingData] = useState([]);
  useEffect(() => {
    getAllListingData();
  }, []);

  const getAllListingData = () => {
    axios.get(REACT_APP_API_ENDPOINT).then((res) => {
      setListingData(res.data);
    });
  };
  const searchListing = (search) => {
    axios
      .get(REACT_APP_API_ENDPOINT, { params: { search: search } })
      .then((res) => {
        setListingData(res.data);
      });
  };
  const [searchTerm, setSearchTerm] = useState("");
  const handleChange = (event) => {
    setSearchTerm(event.target.value);
    searchListing(event.target.value);
  };

  return (
    <div className="AllListings">
      <div className="AllListing__form form-group">
        <div className="AllListing__search-wrap">
          <label className="AllListing__search-input-label">
            <Form.Control
              type="search"
              name="ListingSearch"
              id="listing__search"
              autoComplete="off"
              placeholder="Search a landlord name..."
              onChange={handleChange}
              value={searchTerm}
              className="AllListing__search mb-3"
            />
          </label>
        </div>
        <div className="AllListing__results">
          {listingData.length === 0 ? (
            <LoadingSpinner />
          ) : (
            listingData
              .sort((a, b) => b.postingDate - a.postingDate)
              .map((data) => (
                <SingleListing
                  setLocation={props.setLocation}
                  updateData={getAllListingData}
                  data={data}
                  key={uuidv4()}
                />
              ))
          )}
        </div>
      </div>
    </div>
  );
}
